import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-send\">\n<g id=\"icon-send_&#229;&#143;&#145;&#233;&#128;&#129;&#230;&#140;&#137;&#233;&#146;&#174;\">\n<path id=\"icon-send_Send\" d=\"M22.4937 1.47277C22.3898 1.38323 22.2419 1.36246 22.1165 1.41957L-0.532433 11.7562C-0.654367 11.8119 -0.732888 11.9314 -0.734354 12.0634C-0.73582 12.1955 -0.659881 12.3166 -0.539133 12.3748L5.87048 15.4646C5.98802 15.5213 6.12817 15.5085 6.23315 15.4314L12.4651 10.8562L7.57275 15.7993C7.50295 15.8698 7.46736 15.9664 7.47503 16.0645L7.96214 22.2957C7.97296 22.4337 8.06719 22.5518 8.20113 22.595C8.23693 22.6066 8.27372 22.6122 8.31008 22.6122C8.40982 22.6122 8.50684 22.5702 8.57433 22.4934L11.9763 18.6211L16.1819 20.5949C16.2732 20.6377 16.3789 20.6395 16.4717 20.5999C16.5644 20.5602 16.6351 20.483 16.6653 20.3882L22.5965 1.83318C22.638 1.7036 22.5976 1.56231 22.4937 1.47277Z\" fill=\"currentColor\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/send.svg
// module id = 0zCS
// module chunks = 6 7